import Vue from 'vue';

const Validation = {
  install(Vue) {
    Vue.mixin({
      // computed: mapGetters({
      //   errors: 'validation/errors',
      // }),
    });
  },
};

Vue.use(Validation);
